import React, { useEffect } from 'react'
import { Box, Typography, Divider, Container, Grid, } from '@mui/material'
import { Link } from 'react-router-dom';
import Groupimg from '../../assets/images/Group2.png'
import LogoDarkImg from '../../assets/images/logo-dark.png'
import FbImg from '../../assets/images/Footer1.png'
import TwitterImg from '../../assets/images/Footer2.png'
import UtubeImg from '../../assets/images/Footer3.png'
import linkedin from '../../assets/images/Footer5.svg'
import { useTheme } from '@mui/material/styles'
const Footer = () => {
  const theme = useTheme()
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <Box>
        <Container
          maxWidth='lg'
          sx={{
            px: { xs: 7, md: 10, lg: 5 },
            // py: { xs: 2, sm: 2, lg: 3, xl: 4 },
          }}
        >
          <Grid container spacing={8} sx={{ marginBottom: '40px' }}>
            <Grid item xs={12} sm={4}>
              <Box>
                {theme.palette.mode === 'light' ? (
                  <img src={LogoDarkImg} alt='' style={{
                    height: '90px',
                    width: '90px'
                  }} />
                ) : (
                  <img src={Groupimg} alt='' style={{
                    height: '90px',
                    width: '90px'
                  }} />
                )}
              </Box>
              <Typography sx={{ fontSize: '16px' }}>
                Ask Milo – Your Expert Consultants At Your Fingertips</Typography>
              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: '10px', md: '20px' },
                  flexDirection: 'row',
                  marginTop: '10px'
                }}
              >
                <Link to="https://www.facebook.com/profile.php?id=61565157899950" >
                  <img src={FbImg} alt="Facebook" />
                </Link>
                <Link to="https://x.com/ask_milo2024" >
                  <img src={TwitterImg} alt="Twitter" />
                </Link>
                <Link to="http://www.youtube.com/@AskMilo-g3d" >
                  <img src={UtubeImg} alt="YouTube" />
                </Link>
                <Link to="https://www.linkedin.com/company/ask-milo/?viewAsMember=true">
                  <img src={linkedin} alt="linkedin" />
                </Link>
              </Box>
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography sx={{ color: '#AAC528', fontWeight: 600, fontSize: '18px' }}>Company Links</Typography>
              <Box sx={{ marginTop: '10px' }}>
                <Link to="/knowledge-base" style={{ textDecoration: 'none' }} >
                  <Typography sx={{ marginTop: '10px', fontSize: '16px' }}>Knowledge Base</Typography>
                </Link>
                <Link to="/blog" style={{ textDecoration: 'none' }} >
                  <Typography sx={{ marginTop: '10px', fontSize: '16px' }}>Blogs</Typography>
                </Link>
                {/* <Typography sx={{ marginTop: '10px', fontSize: '16px', }}>Legal</Typography> */}
                <Link to="/affiliate-screen" style={{ textDecoration: 'none' }} >
                  <Typography sx={{ marginTop: '10px', fontSize: '16px' }}>Affiliate Program</Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography sx={{ color: '#AAC528', fontWeight: 600, fontSize: '18px' }}>Useful Links</Typography>
              <Box sx={{ marginTop: '10px' }}>
                <Link to="/privacy-policy" style={{ textDecoration: 'none' }} >
                  <Typography sx={{ marginTop: '10px', fontSize: '16px' }}>Privacy Policy</Typography>
                </Link>
                <Link to="/terms-of-used" style={{ textDecoration: 'none' }} >
                  <Typography sx={{ marginTop: '10px', fontSize: '16px' }}>Terms of Service</Typography>
                </Link>
                <Link to="/our-value" style={{ textDecoration: 'none' }} >
                  <Typography sx={{ marginTop: '10px', fontSize: '16px' }}>AI - Policy</Typography>
                </Link>
                <Link to="/faq" style={{ textDecoration: 'none' }} >
                  <Typography sx={{ marginTop: '10px', fontSize: '16px' }}>FAQs</Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography sx={{ color: '#AAC528', fontWeight: 600, fontSize: '18px' }}>Contact Info</Typography>
              <Box sx={{ marginTop: '10px' }}>
                <a href="mailto:hello@askmilo.ai" style={{ color: 'inherit', textDecoration: 'none' }}>
                support@askmilo.ai
                </a>
                <Typography sx={{ marginTop: '10px', fontSize: '16px' }}> Address: Texas, United States of America</Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={6} sm={2}>
              <Typography sx={{ color: '#AAC528', fontWeight: 600, fontSize: '18px' }}>Additional Links</Typography>
              <Box sx={{ marginTop: '10px', wordBreak: 'break-word' }}>
                <Typography sx={{ marginTop: '10px', fontSize: '16px' }}>
                  <Link to="https://beagile.co.za/" target="_blank"
                    style={{
                      textDecoration: 'none',
                      color: theme.palette.mode === 'light' ? '#000' : '#F9F9F9'
                    }}>
                    www.beagile.co.za</Link>
                </Typography>
                <Typography sx={{ marginTop: '10px', fontSize: '16px', }}>
                  <Link to="https://beagile.co.za/" target="_blank"
                    style={{
                      textDecoration: 'none',
                      color: theme.palette.mode === 'light' ? '#000' : '#F9F9F9'
                    }}>https://atlascopilot.com/?via=myles </Link></Typography>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
        <Divider sx={{ color: '#3D3D3D' }} />
        <Box
          sx={{
            justifyContent: { xs: 'center', md: 'space-between', },
            alignItems: 'center',
            height: '55px',
            padding: { xs: '0 10px', md: '0 20px' },
            display: { xs: 'flex' },
            flexDirection: { xs: 'column', md: 'row', },
          }}
        >
          <Typography
            sx={{
              textAlign: 'center',
              width: '100%',
              fontSize: { xs: '16px', lg: '18px', xl: '20px' },
            }}
          >
            © Ask Milo Pvt Ltd. All rights reserved {currentYear}
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default Footer;
